module.exports = __webpack_public_path__ + "static/img/company_news01.8879ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutMe/company_news01.jpg
// module id = Imrf
// module chunks = 2